import axios, { AxiosError } from 'axios';

function isAbortedOrCanceledHttpError(error: unknown): boolean {
   if (error === 'Request aborted') return true;

   if (!error || typeof error !== 'object') return false;

   const axiosError = error as AxiosError;

   if (axios.isCancel(axiosError)) return true;
   if (axiosError.code === 'ERR_CANCELED') return true;
   if (axiosError.name === 'CanceledError') return true;
   if (axiosError.message === 'Request aborted') return true;
   if (axiosError.config?.signal?.aborted) return true;

   if (typeof axiosError.message === 'string' && axiosError.message.startsWith('Canceled duplicate request')) {
      return true;
   }

   return false;
}

function isTransientHttpError(error: AxiosError): boolean {
   return !error.response && error.code === 'ERR_NETWORK';
}

export { isAbortedOrCanceledHttpError, isTransientHttpError };
